import { createVNode as r, mergeProps as i } from "vue";
import O from "../node_modules/@pf-ui/pf-icon-svg/es/asn/OneToOneOutlined.js";
import l from "../components/PfIcon.js";
const e = (t, n) => {
  const o = {
    ...t,
    ...n.attrs
  };
  return r(l, i(o, {
    icon: O
  }), null);
};
e.displayName = "OneToOneOutlined";
e.inheritAttrs = !1;
export {
  e as default
};
